import styled, { keyframes } from 'vue-styled-components';
import { flexDirection, justifyContent, alignItems, background, space, height, minHeight, margin, display, padding, width, flexBasis, fontSize, lineHeight } from 'styled-system';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n   margin: 80px auto;\n   font-size: 15px;\n   width: 20px;\n   height: 20px;\n   border-radius: 50%;\n   position: relative;\n   text-indent: -9999em;\n   animation: ", " 1.1s infinite ease;\n   transform: translateZ(0);\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n   0%, 100% {\n      box-shadow: 0em -2.6em 0em 0em #000, 1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2), 2.5em 0em 0 0em rgba(0, 0, 0, 0.2), 1.75em 1.75em 0 0em rgba(0, 0, 0, 0.2), 0em 2.5em 0 0em rgba(0, 0, 0, 0.2), -1.8em 1.8em 0 0em rgba(0, 0, 0, 0.2), -2.6em 0em 0 0em rgba(0, 0, 0, 0.5), -1.8em -1.8em 0 0em rgba(0, 0, 0, 0.7);\n   }\n   12.5% {\n      box-shadow: 0em -2.6em 0em 0em rgba(0, 0, 0, 0.7), 1.8em -1.8em 0 0em #ffffff, 2.5em 0em 0 0em rgba(0, 0, 0, 0.2), 1.75em 1.75em 0 0em rgba(0, 0, 0, 0.2), 0em 2.5em 0 0em rgba(0, 0, 0, 0.2), -1.8em 1.8em 0 0em rgba(0, 0, 0, 0.2), -2.6em 0em 0 0em rgba(0, 0, 0, 0.2), -1.8em -1.8em 0 0em rgba(0, 0, 0, 0.5);\n   }\n   25% {\n      box-shadow: 0em -2.6em 0em 0em rgba(0, 0, 0, 0.5), 1.8em -1.8em 0 0em rgba(0, 0, 0, 0.7), 2.5em 0em 0 0em #ffffff, 1.75em 1.75em 0 0em rgba(0, 0, 0, 0.2), 0em 2.5em 0 0em rgba(0, 0, 0, 0.2), -1.8em 1.8em 0 0em rgba(0, 0, 0, 0.2), -2.6em 0em 0 0em rgba(0, 0, 0, 0.2), -1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2);\n   }\n   37.5% {\n      box-shadow: 0em -2.6em 0em 0em rgba(0, 0, 0, 0.2), 1.8em -1.8em 0 0em rgba(0, 0, 0, 0.5), 2.5em 0em 0 0em rgba(0, 0, 0, 0.7), 1.75em 1.75em 0 0em #ffffff, 0em 2.5em 0 0em rgba(0, 0, 0, 0.2), -1.8em 1.8em 0 0em rgba(0, 0, 0, 0.2), -2.6em 0em 0 0em rgba(0, 0, 0, 0.2), -1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2);\n   }\n   50% {\n      box-shadow: 0em -2.6em 0em 0em rgba(0, 0, 0, 0.2), 1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2), 2.5em 0em 0 0em rgba(0, 0, 0, 0.5), 1.75em 1.75em 0 0em rgba(0, 0, 0, 0.7), 0em 2.5em 0 0em #ffffff, -1.8em 1.8em 0 0em rgba(0, 0, 0, 0.2), -2.6em 0em 0 0em rgba(0, 0, 0, 0.2), -1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2);\n   }\n   62.5% {\n      box-shadow: 0em -2.6em 0em 0em rgba(0, 0, 0, 0.2), 1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2), 2.5em 0em 0 0em rgba(0, 0, 0, 0.2), 1.75em 1.75em 0 0em rgba(0, 0, 0, 0.5), 0em 2.5em 0 0em rgba(0, 0, 0, 0.7), -1.8em 1.8em 0 0em #ffffff, -2.6em 0em 0 0em rgba(0, 0, 0, 0.2), -1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2);\n   }\n   75% {\n      box-shadow: 0em -2.6em 0em 0em rgba(0, 0, 0, 0.2), 1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2), 2.5em 0em 0 0em rgba(0, 0, 0, 0.2), 1.75em 1.75em 0 0em rgba(0, 0, 0, 0.2), 0em 2.5em 0 0em rgba(0, 0, 0, 0.5), -1.8em 1.8em 0 0em rgba(0, 0, 0, 0.7), -2.6em 0em 0 0em #ffffff, -1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2);\n   }\n   87.5% {\n      box-shadow: 0em -2.6em 0em 0em rgba(0, 0, 0, 0.2), 1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2), 2.5em 0em 0 0em rgba(0, 0, 0, 0.2), 1.75em 1.75em 0 0em rgba(0, 0, 0, 0.2), 0em 2.5em 0 0em rgba(0, 0, 0, 0.2), -1.8em 1.8em 0 0em rgba(0, 0, 0, 0.5), -2.6em 0em 0 0em rgba(0, 0, 0, 0.7), -1.8em -1.8em 0 0em #ffffff;\n   }"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n   ", "\n   ", "\n\tdisplay: flex;\n   flex-direction: column;\n   width: 100%;\n   color: ", ";\n   justify-content: center;\n   border-radius: 8px;\n   background: rgba(0, 0, 255, 0.4);\n   box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.3);\n   text-shadow: 1px 1px 2px #000;\n   border: 2px solid #fff;\n   padding: 0.6em;\n   height: 100%;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n   background: #f0f0f0;\n   margin: 20px 0;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n   padding-top: 20px;\n   background: #f0f0f0;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n   ", "\n   ", ";\n   ", ";\n   ", ";\n   ", "\n\t", "\n\t", "\n\t", "\n\n   display: flex;\n   box-sizing: border-box;\n   flex: 0 0 auto;\n   padding: 0.3rem;\n\n   /* border-radius: 8px;\n   border: 1px dotted rgba(0, 0, 0, 0.2); */\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n   ", "\n   ", "\n   box-sizing: border-box;\n   display: flex;\n   flex: 0 1 auto;\n   flex-direction: row;\n   flex-wrap: wrap;\n   width: 100%;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\t", "\n\t", "\n\t", "\n\t", "\n\t", "\n\t", "\n\n   width: 100%;\n   display: flex;\n   flex-grow: 1;\n\tmax-width: 1400px;\n\tposition: relative;\n\tpadding-left: 12px;\n\tpadding-right: 12px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n   ", ";\n   ", ";\n   ", ";\n\n   color: blue;\n   position: fixed;\n   width: 100%;\n   background: white;\n   z-index: 100;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\t", "\n\t", "\n\t", "\n\t", "\n\t", "\n\t", "\n\t", "\n\n\tdisplay: flex;\n\twidth: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n   padding: 0;\n   margin: 0;\n   font-family: Avenir, Helvetica, Arial, sans-serif;\n   -webkit-font-smoothing: antialiased;\n   -moz-osx-font-smoothing: grayscale;\n   text-align: center;\n   color: #2c3e50;\n\n   & .fade-enter-active,\n   & .fade-leave-active {\n      transition-duration: 0.1s;\n      transition-property: opacity;\n      transition-timing-function: ease;\n   }\n\n   & .fade-enter,\n   & .fade-leave-active {\n      opacity: 0;\n   }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var App = styled("div")(_templateObject());
var Page = styled("section")(_templateObject2());
var Section = styled("section", {
  // flexDirection: { default: "column", type: [String, Object, Array] },
  // justifyContent: { default: "center", type: [String, Object, Array] },
  flexDirection: {
    default: null,
    type: [String, Object, Array]
  },
  justifyContent: {
    default: "center",
    type: [String, Object, Array]
  },
  alignItems: {
    default: "center",
    type: [String, Object, Array]
  },
  height: {
    default: null,
    type: [String, Object, Array]
  },
  mt: {
    default: null,
    type: [String, Object, Number, Array]
  },
  mb: {
    default: null,
    type: [String, Object, Number, Array]
  },
  background: {
    default: null,
    type: [String]
  },
  minHeight: {
    default: null,
    type: [String]
  },
  padding: {
    default: null,
    type: [String, Object, Number, Array]
  }
})(_templateObject3(), flexDirection, justifyContent, alignItems, background, space, height, minHeight);
var FixedHeader = styled(Section, {
  flexDirection: {
    default: null,
    type: [String, Object, Array]
  },
  ml: {
    default: null,
    type: [String, Object, Number, Array]
  },
  mt: {
    default: null,
    type: [String, Object, Number, Array]
  },
  background: {
    default: null,
    type: [String]
  }
})(_templateObject4(), flexDirection, background, space);
var Center = styled("div", {
  flexDirection: {
    default: null,
    type: [String, Object, Array]
  },
  justifyContent: {
    default: null,
    type: [String, Object, Array]
  },
  alignItems: {
    default: "center",
    type: [String, Object, Array]
  },
  height: {
    default: function _default() {
      return "100%";
    },
    type: [String, Object, Array]
  },
  background: [String],
  ml: [String, Object, Number, Array],
  mt: [String, Object, Number, Array]
})(_templateObject5(), flexDirection, justifyContent, alignItems, background, space, height);
var Row = styled("div", {
  margin: {
    default: function _default() {
      return [1, 1, 1, 2, 3];
    },
    type: [Number, String, Array]
  },
  display: {
    default: function _default() {
      return ["flex"];
    },
    type: [Number, String, Array]
  }
})(_templateObject6(), margin, display);
var Col = styled("div", {
  width: [Array],
  // flexBasis: [Array],
  padding: {
    default: function _default() {
      return [0, 1, 2, 3, 4];
    },
    type: [Array]
  },
  display: {
    default: function _default() {
      return ["flex"];
    },
    type: [Number, String, Array]
  },
  justifyContent: {
    default: null,
    type: [String, Object, Array]
  },
  flexDirection: {
    default: "column",
    type: [String, Object, Array]
  },
  alignItems: {
    default: "center",
    type: [String, Object, Array]
  },
  mt: {
    default: null,
    type: [String, Object, Number, Array]
  },
  mb: {
    default: null,
    type: [String, Object, Number, Array]
  } // maxWidth: {
  //    property: "maxWidth",
  //    default: () => [0, 1, 2, 3, 4],
  //    scale: "sizes",
  //    type: [String, Object, Number, Array]
  // }
  // span: {
  //    property: "span",
  //    default: () => [".2rem", ".4rem", ".6rem", ".8rem"],
  //    type: [Number, String, Array],
  //    scale: "sizes",
  //    cssProperty: "flex-basis"
  // }

})(_templateObject7(), padding, width, flexBasis, display, justifyContent, flexDirection, alignItems, space);
var Footer = styled("footer", {})(_templateObject8());
var Gray = styled("div", {})(_templateObject9());
var SimpleModule = styled("div", {
  fontSize: {
    default: function _default() {
      return [0, 1, 1, 2];
    },
    type: [Number, String, Object, Array]
  },
  lineHeight: {
    default: function _default() {
      return [0, 1, 2, 2];
    },
    type: [Number, String, Object, Array]
  }
})(_templateObject10(), fontSize, lineHeight, function (props) {
  return props.theme.colors.green;
});
var loadingKeyframes = keyframes(_templateObject11());
var LoadingAnimation = styled.div(_templateObject12(), loadingKeyframes);

export { App, Center, Col, FixedHeader, Footer, Gray, LoadingAnimation, Page, Row, Section, SimpleModule };
